import React from 'react';

export const FloatingToys = () => {
  const shapes = [
    // Circles
    { type: 'circle', color: '#fae127', size: 'w-12 h-12', top: '10%', left: '15%', delay: '0s', duration: '12s' },
    { type: 'circle', color: '#8eb2bb', size: 'w-16 h-16', top: '70%', left: '80%', delay: '2s', duration: '15s' },
    { type: 'circle', color: '#ef6728', size: 'w-8 h-8', top: '80%', left: '25%', delay: '4s', duration: '10s' },
    // Triangles
    { type: 'triangle', color: '#fae127', size: 'w-14 h-14', top: '25%', left: '85%', delay: '1s', duration: '14s' },
    { type: 'triangle', color: '#ef6728', size: 'w-10 h-10', top: '65%', left: '10%', delay: '3s', duration: '11s' },
    // Stars
    { type: 'star', color: '#8eb2bb', size: 'w-12 h-12', top: '40%', left: '5%', delay: '5s', duration: '13s' },
    { type: 'star', color: '#fae127', size: 'w-14 h-14', top: '15%', left: '60%', delay: '2s', duration: '16s' },
    { type: 'star', color: '#ef6728', size: 'w-20 h-20', top: '55%', left: '90%', delay: '0s', duration: '18s' },
    // Squares
    { type: 'square', color: '#8eb2bb', size: 'w-12 h-12', top: '85%', left: '55%', delay: '1s', duration: '12s' },
    { type: 'square', color: '#fae127', size: 'w-8 h-8', top: '30%', left: '40%', delay: '4s', duration: '14s' },
  ];

  const renderShape = (shape) => {
    switch (shape.type) {
      case 'circle':
        return <div className={`rounded-full opacity-100 backdrop-blur-sm shadow-lg`} style={{ backgroundColor: shape.color, width: '100%', height: '100%' }} />;
      case 'square':
        return <div className={`rounded-xl opacity-100 backdrop-blur-sm transform rotate-12 shadow-lg`} style={{ backgroundColor: shape.color, width: '100%', height: '100%' }} />;
      case 'triangle':
        return (
          <div className="opacity-100 drop-shadow-lg" style={{
            width: 0,
            height: 0,
            borderLeft: '25px solid transparent',
            borderRight: '25px solid transparent',
            borderBottom: `40px solid ${shape.color}`
          }} />
        );
      case 'star':
        return (
          <svg viewBox="0 0 24 24" fill={shape.color} className="opacity-100 w-full h-full drop-shadow-lg">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {shapes.map((shape, i) => (
        <div
          key={i}
          className={`absolute ${shape.size} animate-float`}
          style={{
            top: shape.top,
            left: shape.left,
            animationDelay: shape.delay,
            animationDuration: shape.duration,
          }}
        >
          {renderShape(shape)}
        </div>
      ))}
    </div>
  );
};
